export default "__VITE_ASSET__CMoOscmI__"